import { authenticate } from '../../entrar/entrar-action';
import config from '../../generated/config';

const { googleAppId } = config;

export const getGoogleLoginObject = () => {
  return new Promise((resolve, reject) => {
    try {
      window.gapi.load('auth2', () => {
        resolve(
          window.gapi.auth2.init({
            client_id: googleAppId
          })
        );
      });
    } catch (error) {
      reject(error);
    }
  });
};

export const loginWithGoogle = async authenticationInfo => {
  try {
    const customer = await authenticate(authenticationInfo);
    return customer;
  } catch (error) {
    return Promise.reject(error);
  }
};
